// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2580":"c641b27f","4111":"c45c1e10","4870":"62a12983","5732":"362bcf3c","6307":"1a658c87","7139":"05ec92ee"}[chunkId] + ".chunk.css";
};